import { useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { ReactSVG } from 'react-svg';
import { Modal } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import Video from '@/components/Video';

import styles from './try-constructor-block.module.css';

export const TryConstructorVideo = ({
  video,
  open,
  onClose,
  onOpen,
  showPlaceholder,
}) => {
  return (
    <div>
      {showPlaceholder && (
        <div className={styles.videoPlacehoder} onClick={onOpen}>
          <img
            src="/images/video_placeholder.svg"
            className={styles.videoPlacehoderImage}
            alt=""
            width="475px"
            height="276px"
          />
          <img
            src="/images/play.svg"
            className={styles.videoPlacehoderPlay}
            alt=""
            width="55px"
            height="55px"
          />
        </div>
      )}
      <ClientWrap>
        <Modal open={open} onClose={onClose} width="1024px">
          <Video
            className={styles.video}
            src={video}
          />
        </Modal>
      </ClientWrap>
    </div>
  );
};

export const TryConstructorBlock = ({ video }) => {
  const { t } = useTranslation();
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div>
      <div className={styles.title}>
        <Trans i18nKey="try_constructor" components={{ accent: <span /> }} />
      </div>
      <div className={styles.subtitle}>{t('service_for_create')}</div>
      <div className={styles.root}>
        <div>
          <ReactSVG src="/images/seo/setting-template.svg" />
          <div>{t('once_set_templates')}</div>
        </div>
        <div>
          <ReactSVG src="/images/seo/create-docs.svg" />
          <div>{t('create_before_minute')}</div>
        </div>
        {/* <div>
          <TryConstructorVideo
            showPlaceholder={true}
            video={video}
            open={showVideo}
            onClose={() => setShowVideo(false)}
            onOpen={() => setShowVideo(true)}
          />
          <div>
            <Trans
              i18nKey="how_do_work_service"
              components={{ accent: <br /> }}
            />
          </div>
        </div>*/}
      </div>
    </div>
  );
};
